import axios from 'axios'
import moment from 'moment'
import Utils from '../../utils/utils'
import CONST from '../../utils/const'
import config from '../../config'

export async function getEmergencyEvents(condition = {}) {
  if (Utils.isEmptyObject(condition.startTime) || Utils.isEmptyObject(condition.endTime)) {
    console.error('getEmergencyEvent: time is null')
    return
  }

  let response = {}
  let startTime = encodeURIComponent(moment(condition.startTime).format().split('+')[0]) //2022-08-05T14:41:00+08:00 移除時區(+之後)
  let startTimeQuery = startTime ? `?startTime=${startTime}` : ''
  let endTime = encodeURIComponent(moment(condition.endTime).format().split('+')[0]) //2022-08-05T14:41:00+08:00 移除時區(+之後)
  let endTimeQuery = startTime ? `&endtime=${endTime}` : ''
  let scenicAreaId = condition.scenicAreaId
  let scenicAreaIdQuery = scenicAreaId === -1 ? '' : `&scenicAreaId=${scenicAreaId}` // 可以不填
  let dismissStatus = condition.dismissStatus
  let dismissStatusQuery = dismissStatus === -1 ? '' : dismissStatus === 1 ? `&dismissStatus=${true}` : `&dismissStatus=${false}` //可以不填

  try {
    response = await axios.get(`${config.eastCoastMonitorApi()}EmergencyEvent/GetEmergencyEventDetail${startTimeQuery}${endTimeQuery}${scenicAreaIdQuery}${dismissStatusQuery}`)

  } catch (err) {
    console.error('getEmergencyEvent: ')
  }

  Utils.setApiResponsSuccess(response)
  return response
}

export async function getEmergencyButtonStatus() {
  let response = {}

  try {
    response = await axios.get(`${config.eastCoastMonitorApi()}EmergencyEvent/GetEmergencyButtonStatus`)

  } catch (err) {
    console.error('GetEmergencyButtonStatus err: ')
    response.data = []
  }

  Utils.setApiResponsSuccess(response)
  response.data = handleLntLng(response)
  return response
}

function handleLntLng(response) {
  if (Utils.isEmptyObject(response) || Utils.isEmptyObject(response.data)) {
    return null
  }

  const data = response.data

  for (let i = 0; i < data.length; i++) {
    data[i] = Utils.handleDeviceLntLng(data[i])
    
    data[i][CONST.TRAFFIC_CCTV_KEY.TYPE] = CONST.MAP_ICON_TYPE.EMERGENCY
  }

  return data
}

export async function postEmergencyEvent(event = {}) {

  let response = {}
    if (Utils.isEmptyObject(event) || Utils.isEmptyObject(event.deviceEventIds) || Utils.isEmptyObject(event.fillAccount)) {
        console.error('iisi postEmergencyEvent: data is null')
        Utils.setApiResponsSuccess(response)
        return response
    }

    // let deviceEventIdQuery = `?deviceEventId=${event.eventId}`
    // let fillAccountQuery = `&fillAccount=${event.fillAccount}`
    // let contentQuery = `&content=${event.content}`
    // let isDismissQuery = `&isDismiss=${event.isDismiss}`

    try {
      response = await axios.post(`${config.eastCoastMonitorApi()}EmergencyEvent/EmergencyEventDismiss`,event)

    } catch (err) {
        console.error('iisi postEmergencyEvent: ', err)
        return response
    }

    Utils.setApiResponsSuccess(response)
    return response
}